// extracted by mini-css-extract-plugin
module.exports = {"section":"RegionsTable_section__3OkPm","link":"RegionsTable_link__2q5iI","backToCountriesBtn":"RegionsTable_backToCountriesBtn__smpYp"};